<template>
	<div class="tc-schedule-list">
		<TCScheduleListRowGroup
			v-for="item in items"
			v-bind:key="item.code"
			v-bind:item=item
			v-bind:watchSlide="watchSlide"
			v-bind:scroll_to="scroll_to"
			v-on:schedule-list-row-slide="onScheduleListRowSlide"
			v-on:add-task-info="onClickAddTaskInfo"
			v-on:show-task-info="onClickShowTaskInfo"
			v-on:show-member-info="onClickShowMemberInfo"
			v-on:show-project-info="onClickShowProjectInfo"
			v-on:delete-task="onClickDeleteTask"
		/>
	</div>
</template>
<script>
import TCScheduleListRowGroup from './TCScheduleListRowGroup';
export default {
	name: 'TCScheduleList',
	props: [
		"items",
		"scroll_to",
	],
	components: {
		TCScheduleListRowGroup,
	},
	data() {
		return {
			watchSlide: null,
		};
	},
	methods: {
		onClick: function(e) {
			this.watchSlide = {
				type: 'click',
				target: e,
				status: null,
			};
		},
		onScheduleListRowSlide: function(e) {
			this.watchSlide = {
				type: 'slide',
				target: e.target,
				status: e.status,
			};
		},
		onClickAddTaskInfo: function(e) {
			this.$emit("add-task-info", e);
		},
		onClickShowTaskInfo: function(e) {
			this.$emit("show-task-info", e);
		},
		onClickShowMemberInfo: function(e) {
			this.$emit("show-member-info", e);
		},
		onClickShowProjectInfo: function(e) {
			this.$emit("show-project-info", e);
		},
		onClickDeleteTask: function(e) {
			this.$emit("delete-task", e);
		},
	},
	computed: {
	},
	mounted: function() {
		window.addEventListener('click', this.onClick, false);
	},
	beforeDestory: function() {
		window.removeEventListener('click', this.onClick, false);
	},
}
</script>
<style>
	.tc-schedule-list {
		flex: 0 0 300px !important;
		width: 300px;
		background-color: white;
		z-index: 101;
		border-right: 1px solid #dfdfdf;
	}
</style>
